module.exports = __webpack_public_path__ + "img/Frame 9.png";